import type { AppConfigDto } from '@/types/webapi';
import { IConfigService } from './IConfigService';
import { injectable } from 'inversify';
import { useMainStore } from '@/features/common/stores';
import { ax } from '@/plugins/axios';

@injectable()
export class AppConfigService implements IConfigService {
    _mainStore: ReturnType<typeof useMainStore>;

    get mainStore(): ReturnType<typeof useMainStore> {
        if (!this._mainStore) {
            this._mainStore = useMainStore();
        }

        return this._mainStore;
    }

    getConfig() {
        return new Promise<AppConfigDto>((resolve, reject) => {
            ax.get('/api/v1.0/config')
                .then(response => resolve(response.data))
                .catch(e => {
                    this.mainStore.registerError(e);
                    reject(new Error(e.message || 'Failed to get config'));
                });
        });
    }
}
